import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import FsLightbox from "fslightbox-react";
import { Banner } from "../../components/Banner/Banner";
import {
  bloginnerban,
  facebook,
  gallery1,
  leftarrow,
  mainimg,
  moreblog1,
  moreblog2,
  moreblog3,
  coloredArrow,
  playicon,
  whatsapp,
  linkedinblog,
  twitterblog,
  copy,
  mainimgmob,
  bannerInner3,
  blog5Banner
} from "../../images";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { Link, NavLink } from "react-router-dom";
//utils
import { reduceDescSize } from "../../helpers/utils";

import "./BlogInner5.scss";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const BlogInner = () => {
  const { width } = useWindowDimensions();
  const [copied, setCopied] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [vidLink, setVidLink] = useState("");

  const blogDateArr = [
    {
      date: "June 2, 2022",
      category: "Lorem Ipsum",
      company: "Sanathan",
    },
  ];

  const blogDescArr = [
    {
      id: 1,
      heading: "What Are Some Examples Of Technical Textiles?",
      desc1:
        "Technical textiles in India are a vital component of modern life. These materials are employed in a wide range of industries, from medical gadgets to athletic products. This article will provide an overview of technical textiles, their examples and how it is used nowadays.<br/><br/>First, Let’s understand what is Technical Textile? <br/><br/><strong> What Are Technical Textiles?</strong><br/> <br/>Technical textiles, also known as smart textiles are textile components and products with technical traits and characteristics. It is a textile product manufactured for non-aesthetic purposes, where the function is the primary criterion. They are created from natural and man-made fibres such as Nomex, Kevlar, Spandex, and Twaron, which have better functional features such as higher tenacity, excellent insulation, improved thermal resistance, and so on.<br/><br/> Technical textiles are a promising position in the textile industry. It is employed for the proper application of its functional features and the production of diverse applications. <br/><br/><strong>9 Technical Textiles Examples:</strong><br/>  <br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>1. Agrotextiles (Agro-Textiles)</strong><br/>Technical textile applications in agriculture cover all tasks related to the cultivation and harvesting of crops and animals. The primary role of most agricultural textiles is to protect food, animals, or land. Crop production, forestry and horticulture, livestock and poultry husbandry, and fishing are all examples of end uses. The fishing industry consumes a lot of textile materials. Fishing practices are becoming increasingly industrialized, with small net and line fishing techniques being phased out.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 2. Geotextiles (Geo-Textiles)</strong><br/> Geotextiles are all woven, nonwoven, and knitted textile materials used primarily by the civil engineering sector to provide support, drainage, and isolation at or below ground level. Geotextiles are used in a variety of applications, including building, bridge, dam, road, railway, and path construction, as well as embankments, cuttings, dykes, and sub- sea coastal engineering projects. These are increasingly being used for waste containment in hazardous waste disposal sites and industrial and municipal effluent treatment facilities.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 3. Hometech (Domestic Textiles)</strong><br/> Hometech is the fourth-largest seller of technical textiles in the world. Hometech products contain both synthetic and natural fibres. Western countries account for the biggest market share of hometech textiles followed by the Asia Pacific region. Hometech textiles are majorly used in furniture &amp; interior decoration, sun protection, cushion materials, carpeting, fireproofing, wall coverings, flooring and textile reinforced fittings etc. The hometech textiles market is supposed to observe a great increase of 4.8% CAGR year on year.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>4. Indutech (Industrial Textiles)</strong><br/> Indutech refers to textiles used in several industrial applications. There is increasing demand from uses like cleansing, conveyancing industrial instrumentation, agriculture and farming, environmental protection, sport and leisure, unit furnishing and coverings, and packaging. Technical textiles are proving their worth in yet another field, contributing to the advancement of industrial and technological growth. Technical textiles include mechanical and textile engineering goods and solutions. Indutech Textiles Market size is growing at a moderate pace with substantial growth rates over the last few years. It estimated that the market will grow significantly in the period from 2021 to 2028.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>5. Medtech (Medical Textiles) </strong><br/>The word MedTech refers to technical textiles used in the medical and rehabilitation industries. It entails the development, processing, and application of safe and sanitary products. Medical textiles from the MedTech sector help patients get the best care possible. Because of their high process dependability requirements, MedTech products are among the most advanced technical textiles. Textiles materials that are used in medical applications include fibres, yarns, fabrics and composites. Depending upon the application, the major requirements of medical textiles are absorbency, tenacity, flexibility, softness and at times biostability or biodegradability.<br/><br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 6. Mobiltech (Textiles Used In Transport)</strong><br/> Mobiltech textiles are utilised in the automotive and transportation industries. It&#39;s some sort of technological fabric. Some of the uses are automobiles, automotive components, aircraft and railways. Mobiltech is concerned with more than just isolation and safety; it is also concerned with comfort and aesthetics. Mobiltech is used in seatbelt webbing, car upholstery, airbags, helmets and tyre cords. Materials like nylon, polyester and polyester blends are used extensively in mobiltech.<br/><br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>7. Ecotech (Eco-Friendly Textiles) </strong><br/>Oekotech or Ecotech is a textile application in environmental protection. It includes floor sealants, erosion protection, air cleaning, water pollution prevention, water cleaning, waste treatment/recycling, depositing area construction, product extraction, and household water sewerage plant. The key component in this is landfill waste management and the secondary protection is the chemical/oil industries. <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>8. Protech (Protective Textiles)</strong><br/>Protective textile is a type of technical cloth that has exceptional protective properties to protect against a wide range of natural and man-made threats. It occasionally has smart e-textile features like chemical, heat and cold protection, and so on are all examples of protective functioning. Protective textiles has important use cases in frie suits, chemical clothing, biological suits, and ballistic vests. In most cases we can find it in bullet proof vests as well as space suits.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 9. SportTech (Sports Textiles)</strong><br/> Sports textiles, also known as Sporttex, are primarily utilised in the production of sportswear, such as sports shoes and other sports equipment. The growing popularity of active sports and outdoor leisure activities such as flying, sailing, climbing, and cycling has resulted in a massive increase in the use of textile materials in the production of sporting and related items and equipment. In the production of athletic textiles, synthetic fibres and coatings have essentially supplanted conventional cotton fabrics and other natural fibres.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 10. Clothtech (Clothing Textiles)</strong> <br/>Clothtech is a technical textile subset that includes all textile materials used in garments, footwear, laces, interlinings, zip fasteners, elastic narrow fabrics (tapes), Velcro, labels, umbrella cloth, and sewing threads. Technical textiles for clothing, particularly in the finishing process, where the fabric is handled under high pressure and high temperatures, support the fabric and allow for the procedure to be carried out progressively. Typically, this is a polyester blend.<br/><br/><strong> Conclusion</strong><br/> Finally, we examined one of the most significant inventions of the recent decade: technical textiles. At first glance, it may appear to be just another material, but upon closer inspection, you&#39;ll notice that it has transformed many facets of our lives, from medicine hygiene goods to sporting apparel. <br/><br/><strong>About Sanathan Textiles </strong><br/>Sanathan Textiles is a polyester manufacturer and a global supplier of Cotton Yarns, Polyester Yarns and Yarns for Technical Textiles. With 3 yarn business verticals, we offer a wide variety of yarns that are used by various sectors and industries, across applications and end-uses. Technologically advanced and environmentally conscious manufacturing setup enables us to offer customers value-added yarns, niche yarns, functional yarns and a wide range of coloured yarns. Sanathan Textiles is committed to providing Value added Innovative Yarns for the Fabric of our Lives.",
    },
  ];

  const moreblogsArr = [
    {
      img: moreblog1,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog3,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
  ];

  const galleryArr = [
    {
      id: 1,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 2,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 3,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 4,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
  ];

  useEffect(() => {
    var gallery_swiper_container = new Swiper(
      ".swiper-container.gallery_swiper_container",
      {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          prevEl: ".bloginner_sec2 .left_arrow",
          nextEl: ".bloginner_sec2 .right_arrow",
        },
        breakpoints: {
          767: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2.7,
            spaceBetween: 10,
          },
        },
        // loop: true,
        // centeredSlides: true,
        // loopedSlides: thumbArr.length, //how many slides it should duplicate
      }
    );
    var moreblogs_swiper_container = new Swiper(
      ".swiper-container.moreblogs_swiper_container",
      {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: false,
        navigation: {
          prevEl: ".bloginner_sec3 .left_arrow",
          nextEl: ".bloginner_sec3 .right_arrow",
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          767: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      }
    );
  });

  useEffect(() => {
    if (copied) {
      let copiedTimeout = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copied]);

  const dateList = blogDateArr.map((item) => (
    <>
      <p className="blog_date">{item.date} | </p>
      <p className="blog_category"> {item.category} </p>
      <p className="blog_company">| {item.company}</p>
    </>
  ));

  const descList = blogDescArr.map((item) => (
    <>
      <p
        className="blog_desc"
        dangerouslySetInnerHTML={{ __html: item.desc1 }}
      />
    </>
  ));

  const galleryVideoImageList = galleryArr.length
    ? galleryArr.map((item, i) => (
        <div className="swiper-slide" key={i}>
          {item.type == "video" ? (
            <>
              <div
                className="video_wrapper_div"
                onClick={() => handleImageWrapperClick(item.ytLink)}
              >
                <div className="content">
                  <img
                    src={item.image}
                    alt="Sanathan video gallery img"
                    loading="lazy"
                    className="gallery_img"
                  />
                  <div className="content-overlay"></div>
                  <img
                    src={playicon}
                    alt="Sanathan coloredArrow img"
                    loading="lazy"
                    className="playicon"
                    onClick={() => handleImageWrapperClick(item.ytLink)}
                  />
                  {/* <h2 className="galleryImageName">{item.title}</h2> */}
                </div>

                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          ) : (
            <>
              <div className="content">
                <img
                  src={item.image}
                  alt="Sanathan blog gallery img"
                  loading="lazy"
                  className="gallery_img"
                />
                <div className="content-overlay"></div>
                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          )}
        </div>
      ))
    : null;

  const moreblogsList = moreblogsArr.map((item, i) => (
    <>
      <li className="swiper-slide moreblog_detail_wrapper">
        <Link to="/blog-inner" key={i}>
          <div className="imageanimate zoom-out">
            <img
              src={item.img}
              alt="Sanathan our blog img"
              loading="lazy"
              className="moreblog_img"
            />
            {/* <div className="content-overlay"></div> */}
          </div>
          <div className="text_container">
            <h1 className="moreblog_date">{item.date}</h1>
            <div className="verticle_line"> | </div>
            <h1 className="moreblog_category"> {item.category}</h1>
            <h1 className="moreblog_name">{item.title}</h1>
            <p className="moreblog_synopsis">
              {reduceDescSize(item.desc, 100)}
            </p>
            <div className="moreblog_cta_wrapper"></div>
          </div>
        </Link>
      </li>
    </>
  ));

  const handleImageWrapperClick = (videoLink) => {
    setToggler(!toggler);
    setVidLink(videoLink);
  };

  const copyUrl = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Sanathan Textiles: Polyester Yarn Market Report And The Price Trend In India 2022"
        metaDesc="Polyester is the most cost-effective and versatile synthetic fibre available in the industry."
      />
      {/* <Banner
        imgSrc="https://via.placeholder.com/1920x300"
        breadcrumbWord1="Home"
        breadcrumbWord3="Blogs"
        breadcrumbWord4={blogDescArr[0].heading}
        link3="blogs"
        disabled
      /> */}
      <section className="bloginner_sec1" data-aos="fade-in">
        <div className="wrapper">
          {/* <div className="breadcrumb_styles">Home {">"} Blog Inner</div> */}
          {/* <div className="blog_heading">
            Blog Heading will come here lorem ipsum lorem ipsum example text
            here
          </div> */}
          <img
            className="mainimg"
            src={blog5Banner}
            alt="re-weaving-indias-success-story"
          />
          <div className="row social_icon_date">
            <div className="col-md-6 col-lg-4 datecat_list">
              {/* {dateList} */}
            </div>
            <div className="col-md-1 col-lg-4"></div>
            <div className="col-md-5 col-lg-4">
              {width < 767 ? <h2 className="share_title">Share</h2> : null}
              <div className="social_main_wrapper">
                <ul className="social_icons">
                  {width > 767 ? (
                    <li className="social_icon_li">
                      <h2 className="share_title">Share</h2>
                    </li>
                  ) : null}
                  <li className="social_icon_li">
                    <FacebookShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={facebook}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </FacebookShareButton>
                  </li>
                  <li className="social_icon_li">
                    <WhatsappShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={whatsapp}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </WhatsappShareButton>
                  </li>
                  <li className="social_icon_li">
                    <TwitterShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={twitterblog}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </TwitterShareButton>
                  </li>
                  <li
                    className="social_icon_li social_icon_li_copy"
                    onClick={copyUrl}
                  >
                    <span className="social_icon">
                      <img
                        src={copy}
                        alt="Sanathan copy url logo"
                        loading="lazy"
                      />
                    </span>
                    <span className="social_name">
                      {!copied ? "" : "Copied!"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="horizontal_line"></div>
          <h1 className="blog_inner_name">
          Polyester Yarn Market Report And The Price Trend In India 2022
          </h1>
          <div className="blog_desc">
            <p>
              <strong>
                Polyester Yarn Market In India{" "}
              </strong>
            </p>
            <p>
            Polyester is the most cost-effective and versatile synthetic fibre available in the industry. Given that the global growth of natural fibres is constrained by available resources, only polyester would see further capacity expansion.
            </p>
            <p>&nbsp;</p>
            <p>
            The increasing use of polyester filament yarn in the textile industry is expected to drive market growth in the coming years in India. This is because the increasing applications of polyester yarns among end-users are driving the market growth. These yarns, for example, have good elasticity, shape retention, wrinkle resistance, exceptional wash &amp; wear performance, washability, and longevity. Therefore, they are used in a variety of applications such as circular knitting, warp knitting, weaving, elastics, narrow fabrics, twisting, yarn dyeing, industrial applications, home furnishings, fashion apparel, threads, ropes, cords, footwear, and so on.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Price Trend Of Polyester Yarn In India 2022 </strong>
            </p>
            <p>
            Last year, polyester yarn manufacturers reported strong growth with revenue increasing by 60%. A combination of factors is expected to support double-digit growth in the current year.
            </p>
            <p>&nbsp;</p>
            <p></p>
            <p>
            End-user demand and increased blending with cotton yarn due to decadal high cotton prices will boost polyester yarn makers&#39; revenue by 18-20% this year. According to a report released by rating agency Crisil, the industry&#39;s growth spree will continue this fiscal year, resulting in higher operating margins, stronger balance sheets, and a better credit outlook.
            </p>
            <p>&nbsp;</p>
            <p>
            Demand is expected to remain strong this year as well, with the garments and home textiles segments expected to grow at 16-18% and 12-13%, respectively by the end of March 31, 2023. According to CRISIL, growth will be driven by a recovery in domestic demand and moderate growth in exports.
            </p>
            <p>&nbsp;</p>
            <p>
            Additionally, it is anticipated that the polyester yarn segment&#39;s operating profitability will rise by 100 basis points to about 11%, led by ongoing high capacity utilisation (over 90%) because of rising demand and a robust polyester yarn spread. An analysis of 24 businesses that represent roughly 40% of the sector&#39;s revenues reveals that improved profitability and anticipated moderate capital spending will improve the credit profiles of polyester yarn makers.
            </p>
            <p>&nbsp;</p>
            <p>
            Average spreads reached a five-year high of around Rs 29 per kg last fiscal year, up from Rs 22 per kg the previous fiscal year, and are expected to remain stable at Rs 28-29 per kg in 2022.
            </p>
            <p>&nbsp;</p>
            <p>
            However, the prices of both crude derivatives- Purified Terephthalic Acid (PTA) and Mono- Ethylene Glycol (MEG) have risen sharply as a result of supply chain issues caused by Russia&#39;s invasion of Ukraine in February. They account for almost 80% of raw material costs for polyester yarn manufacturers.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>
              Future Of Polyester Yarn In India{" "}
              </strong>
            </p>
            <p>
            The polyester yarn sector will benefit from favourable demand-supply dynamics, as there will be no significant capacity additions in the industry over the next two fiscal years.
            </p>
            <p>&nbsp;</p>
            <p>
            Simultaneously, the continued wide price differential between cotton yarn and polyester yarn will result in increased blending among downstream players, driving up demand for polyester yarn even further. If the price differential between cotton and polyester yarns remains stable, the report predicts that 4-5 percent of cotton yarn demand will shift to polyester yarn.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>About Sanathan Textiles</strong>
            </p>
            <p>
              Sanathan Textiles is a global supplier of <a href="/products/cotton-yarn" target="_blank"> Cotton Yarns </a>{" "}, <a href="/products/polyester-yarn" target="_blank"> Polyester Yarns </a> and <a href="/products/yarn-for-technical-textile" target="_blank"> Yarns for Technical Textiles </a>. With 3 yarn business verticals, we offer a wide variety of yarns that are used by various sectors and industries, across applications and end-uses. Technologically advanced and environmentally conscious manufacturing setup enables us to offer customers value-added yarns, niche yarns, functional yarns and a wide range of coloured yarns. Sanathan Textiles is committed to providing Value added Innovative Yarns for the Fabric of our Lives.
            </p>
            <p>&nbsp;</p>
           
          </div>

          {/* <div>{descList}</div> */}
        </div>
      </section>

      {/* {galleryVideoImageList && (
        <section className="bloginner_sec2" data-aos="fade-up">
          <div className="wrapper">
            <div className="heading_arrow_flex">
              <div className="gallery_heading">Gallery</div>
              {width > 767 ? (
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              ) : null}
            </div>
            <div className="gallery_slider_wrapper">
              <div className="swiper-container gallery_swiper_container">
                <div className="swiper-wrapper">{galleryVideoImageList}</div>
              </div>
              {width < 767 ? (
                <div className="arrows_wrapper">
                  <div className="navigations">
                    <button className="left_arrow">Previous</button>
                    <button className="right_arrow">Next</button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      )} */}

      {/* <section className="bloginner_sec3" data-aos="fade-up">
        <div className="horizontal_line"></div>
        <div className="wrapper">
          <div className="heading_arrow_flex2">
            <h2 className="moreblog_heading">More Blogs</h2>
            {width > 767 ? (
              <div className="navigations">
                <button className="left_arrow">Previous</button>
                <button className="right_arrow">Next</button>
              </div>
            ) : null}
          </div>

          <div className="moreblogs_wrapper">
            <div className="swiper-container moreblogs_swiper_container">
              <ul className="swiper-wrapper moreblogs_swiper_wrapper">
                {moreblogsList}
              </ul>
            </div>
            {width < 767 ? (
              <div className="arrows_wrapper">
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section> */}
      {/* <FsLightbox toggler={toggler} sources={[vidLink]} /> */}
    </>
  );
};

export default BlogInner;
